import { useFormik } from "formik";
import * as Yup from "yup";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Axios from "axios";
import { URL_LIST_ALL } from "../../configs/api";
import { useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";

import AkkhorLayout from "../../layout/AkkhorLayout";
import AlertErrorForm from "../../component/AlertErrorForm";
import List from "../../component/List";

export default function FormGdKh() {
    const { user } = useSelector((state) => state.auth);

    const { id } = useParams();
    const [autoRefresh, setAutoRefresh] = useState(false);
    const [listTransactions, setListTransactions] = useState([]);
    const [detail, setDetail] = useState(null);

    const defaultdetail = {
        author_id: user.data.id,
        title: '',
        alias: '',
        budget: '',
        author_id: user.data.id,
        status: 1
    }
    useEffect(
        function () {
            if (id > 0) {
                Axios.get(URL_LIST_ALL + "customers/" + id, user.config)
                    .then(async (res) => {
                        if (res.data.status === "success") {
                            setDetail(res.data.data);
                        } else console.log(res.data.message);
                    })
                    .catch((err) => console.log(err));
            }
        }, [user, id, autoRefresh]
    );

    let validForm = {
        fullname: Yup.string().trim().nullable().required('Nhập tên khách hàng').max(250, "Độ dài không quá 250 ký tự"),
        cccd_id: Yup.string().trim().nullable().required('Nhập số căn cước công dân'),
        mobile: Yup.string().trim().nullable().required('Nhập số điện thoại'),
    }

    const formik = useFormik({
        initialValues: detail ? detail : defaultdetail,
        enableReinitialize: true,
        validationSchema: Yup.object().shape(validForm),
        onSubmit: (values, { setSubmitting, resetForm }) => {
            delete values["id"];
            console.log(values);
            if (id > 0) {
                Axios.put(URL_LIST_ALL + 'customers/' + id, values, user.config).then(res => {
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        setAutoRefresh(!autoRefresh)
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn cập nhật khách hàng thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            } else {
                Axios.post(URL_LIST_ALL + 'customers', values, user.config).then(res => {
                    setSubmitting(false);
                    setAutoRefresh(!autoRefresh)
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn thêm mới khách hàng thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch(err => console.log(err));
            }
        },
    });

    const columns = [
        { name: "id", label: "ID" },
        {
            name: "customers", label: "Thông tin khách hàng",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (value) {
                        return value.map((item) => <div className="w-100 p-2 mb-1 rounded bg-white border">
                            <div className="w-100 flex">
                                <span>Họ tên: </span>
                                <strong>{item.fullname}</strong>
                            </div>
                            <div className="w-100 flex">
                                <span>Số điện thoại: </span>
                                <strong>{item.mobile}</strong>
                            </div>
                        </div>)
                    }
                    return null
                },
            }
        },
        {
            name: "product_id", label: "Thông tin sản phẩm",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {

                    return <div>
                        <div className="w-100 flex">
                            <span>Tên sản phẩm: </span>
                            <strong>{tableMeta.banghang_title}</strong>
                        </div>
                        <div className="w-100 flex">
                            <span>Dự án: </span>
                            <strong>{tableMeta.duan_title}</strong>
                        </div>
                    </div>
                },
            }
        },
        {
            name: "status", label: "Trạng thái",
            options: {
                filter: false, sort: true,
                customBodyRender: (value, tableMeta, updateValue) => {
                    if (value == 1) return "Hoạt động"
                    if (value == 0) return "Ngừng hoạt động"
                    return null
                },
            }
        },
        { name: "author_name", label: "Người tạo" },
        { name: "datecreate", label: "Ngày thêm", }
    ];

    return (
        <AkkhorLayout idrole="khach-hang">
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>
                    <li>
                        <Link to="/khach-hang">Danh sách khách hàng</Link>
                    </li>
                    <li>{id ? 'Sửa thông tin khách hàng' : 'Thêm mới khách hàng'}</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">

                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-6">
                                <div className="item-title">
                                    <h3>{!id ? 'Thêm mới' : 'Sửa'} Thông tin khách hàng</h3>
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="w-100 d-flex justify-content-end form-group">
                                    <button type="submit" disabled={formik.isSubmitting} className="btn btn-success">{formik.isSubmitting ? <div className="loader"></div> : <>Lưu lại</>}</button>
                                    <button type="reset" onClick={formik.resetForm} className="btn btn-warning ml-2">Nhập lại</button>
                                </div>
                            </div>
                            <div className="col-12 form-group mt-2">
                                <label>Họ và tên <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" {...formik.getFieldProps("fullname")} />
                                <AlertErrorForm formik={formik} name="fullname"></AlertErrorForm>
                            </div>
                            <div className="col-12 col-sm-3 form-group ">
                                <label>Số điện thoại <span className="text-danger">*</span></label>
                                <input type="text" className="form-control" {...formik.getFieldProps("mobile")} />
                                <AlertErrorForm formik={formik} name="mobile"></AlertErrorForm>
                            </div>
                            <div className="col-12 col-sm-3 form-group ">
                                <label>Email</label>
                                <input placeholder="VD: abc@domain.com" type="text" className="form-control" {...formik.getFieldProps("email")} />
                            </div>
                            <div className="col-12 col-sm-3 form-group ">
                                <label>Địa chỉ</label>
                                <input placeholder="VD: Số 6 Lê Văn Thiêm,..." type="text" className="form-control" {...formik.getFieldProps("address")} />
                            </div>
                            <div className="col-12 col-sm-3 form-group ">
                                <label>Số căn cước công dân <span className="text-danger">*</span></label>
                                <input placeholder="VD: 0023456777" type="text" className="form-control" {...formik.getFieldProps("cccd_id")} />
                                <AlertErrorForm formik={formik} name="cccd_id"></AlertErrorForm>
                            </div>

                            <div className="col-12 col-sm-3 form-group ">
                                <label>Nơi cấp</label>
                                <input placeholder="VD: Cục Cảnh sát QLHC về TTXH" type="text" className="form-control" {...formik.getFieldProps("cccd_noicap")} />
                            </div>
                            <div className="col-12 col-sm-3 form-group ">
                                <label>Ngày cấp</label>
                                <input placeholder="VD: 15-02-2025" type="date" className="form-control" {...formik.getFieldProps("cccd_date")} />
                            </div>
                            <div className="col-12 col-sm-3 form-group ">
                                <label>Ngày sinh</label>
                                <input placeholder="VD: 15-02-2025" type="date" className="form-control" {...formik.getFieldProps("birthday")} />
                            </div>
                            <div className="col-12 col-sm-3 form-group ">
                                <label>Địa chỉ thường chú</label>
                                <input placeholder="VD: Số 6 Lê Văn Thiêm,..." type="text" className="form-control" {...formik.getFieldProps("cccd_address")} />
                            </div>
                            <div className="col-12 form-group ">
                                <label>Nội dung ghi chú</label>
                                <textarea type="text" placeholder="Nhập nội dung" className="form-control" {...formik.getFieldProps("note")} autoComplete="off"></textarea>
                            </div>
                            {id > 0 &&
                                <List name="transactions" idrole="giao-dich" params={"customer_id=" + id} title="" defaultLimit={50} serverSide={true} columns={columns}></List>
                            }
                            <div className="col-12 d-flex justify-content-end form-group">
                                <button type="submit" disabled={formik.isSubmitting} className="btn btn-success">{formik.isSubmitting ? <div className="loader"></div> : <>Lưu lại</>}</button>
                                <button type="reset" onClick={formik.resetForm} className="btn btn-warning ml-2">Nhập lại</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
